require('./departments.route');
require('./departments.controller');
require('./department-form.controller');
